import clsx from 'clsx'
import { ArrowRightIcon, type LucideIcon } from 'lucide-react'
import React from 'react'

import { TextLink } from 'slab'

interface BorderedBannerProps {
  icon?: LucideIcon;
  text: string;
  linkText?: string;
  onLinkClick?: () => void;
}

export const BorderedBanner: React.FC<BorderedBannerProps> = ({
  icon: Icon,
  text,
  linkText,
  onLinkClick,
}) => {
  const shouldShowLink = linkText && onLinkClick

  return (
    <div className='flex items-center rounded-lg border border-thatch-600 bg-gradient-to-b from-thatch-200 via-thatch-100 to-transparent p-4'>
      {Icon && (
        <Icon className='flex-shrink-0 text-thatch-500 mr-4' size={20} />
      )}

      <span
        className={clsx('flex-1 text-main body-bold', {
          'mr-2': shouldShowLink,
        })}
      >
        {text}
      </span>

      {shouldShowLink && (
        <TextLink onClick={onLinkClick} rightIcon={ArrowRightIcon}>
          <span className='cursor-pointer text-main body-bold'>{linkText}</span>
        </TextLink>
      )}
    </div>
  )
}

export default BorderedBanner
